module.exports = ".close-btn-wrapper{position:relative;top:-23px;right:-32px}\n"